import { gql } from "@apollo/client";

export const QUERY_GET_PROCESS_STAGE = gql`
  query QUERY_GET_PROCESS_STAGE($processId: Int) {
    processStage(where: {processId: {_eq: $processId}}) {
      id
      descript
      expirationTime
      isAutomatic
      nextStageId
      processId
      stageName
    }
  }
`;

export const QUERY_GET_ALL_PROCESS_GROUP_STAGES = gql`
  query QUERY_GET_ALL_PROCESS_GROUP_STAGES {
    groupStage {
      comment
      value
    }
  }
`

export const QUERY_GET_ALL_PROCESS_GROUP_STAGES_BY_PROCESS_ID = gql`
  query QUERY_GET_ALL_PROCESS_GROUP_STAGES_BY_PROCESS_ID($processId: Int) {
    groupStage(where: {processStages: {processId: {_eq: $processId}}}) {
      comment
      value
    }
  }
`;